import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-100/50 border-t border-background-200">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg text-foreground-900 mb-4">
              韩漫在线
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              韩国漫画在线提供免费漫画阅读，体验下拉式韩漫大全功能。海量韩国漫画资源，让阅读变得丰富多彩而轻松。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  恋爱漫画
                </Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  奇幻漫画
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  动作漫画
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              更多分类
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/thriller" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  悬疑漫画
                </Link>
              </li>
              <li>
                <Link to="/category/slice-of-life" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  日常漫画
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-base w-4 h-4 flex items-center justify-center"></i>
                <span>support@koreancomics.cn</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-customer-service-2-line text-base w-4 h-4 flex items-center justify-center"></i>
                <span>在线客服：周一至周五 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩国漫画在线 - 韩漫网站。本站内容仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">
              版权声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}